export const scheme = {
  light: `(prefers-color-scheme: light)`,
  dark: `(prefers-color-scheme: dark)`,
};
